import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import moment from 'moment'
import * as jobSearchDuck from '../../jobSearchDuck'
class SavedJobsResult extends Component {
  static propTypes = {
    job: PropTypes.any.isRequired,
    onDelete: PropTypes.func.isRequired,
  }

  render() {
    const {
      onDelete,
      job: { _id, createdAt, job_data },
      selectJobTitle,
    } = this.props

    const { JobTitle, JobDetailsURL, job_id } = job_data

    const handleSelectSavedSearch = () => {
      const selectedJob = {
        ...job_data,
        savedSearchId: _id,
      }

      selectJobTitle(selectedJob)
    }

    const isLegacyJob = !job_id
    if (isLegacyJob) {
      if (!JobTitle || !JobDetailsURL) {
        return null
      }
    }

    return (
      <div className="row m-0">
        <div style={{ marginBottom: 8 }}>
          {isLegacyJob ? (
            <Link
              to={JobDetailsURL ? JobDetailsURL : '/'}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="row m-0">
                <div style={{ width: 40, textAlign: 'center' }}>
                  <i className="fal fa-save" style={{ fontSize: 20, paddingTop: 4 }} />
                  <div style={{ fontSize: 8, textAlign: 'center', marginTop: -3 }}>
                    {createdAt && `${moment(createdAt).format('MMM D')}`}
                  </div>
                </div>
                <div className="link-search-box">{JobTitle}</div>
                <div className="link-search-button">
                  <i className="fal fa-search" />
                </div>
              </div>
            </Link>
          ) : (
            <div className="row m-0 clickable-green" onClick={handleSelectSavedSearch}>
              <div style={{ width: 40, textAlign: 'center' }}>
                <i className="fal fa-save" style={{ fontSize: 20, paddingTop: 4 }} />
                <div style={{ fontSize: 8, textAlign: 'center', marginTop: -3 }}>
                  {createdAt && `${moment(createdAt).format('MMM D')}`}
                </div>
              </div>
              <div className="link-search-box">{job_data.title}</div>
              <div className="link-search-button">
                <i className="fal fa-search" />
              </div>
            </div>
          )}
        </div>

        <div style={{ marginLeft: -10, marginTop: -10 }}>
          <div onClick={() => onDelete({ id: _id })}>
            <i className="fas fa-circle close-x" style={{ color: 'white', width: 0 }} />
            <i className="fal fa-times-circle close-x" style={{ color: '#EE6352' }} />
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      selectJobTitle: jobSearchDuck.selectJobTitle,
    },
    dispatch,
  )

export default connect(null, mapDispatchToProps)(SavedJobsResult)



// WEBPACK FOOTER //
// ./src/routes/authenticated/JobSearch/components/SavedJobs/SavedJobsResult.js